import React, { useState } from "react";
import "./LearningJourney.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabsUnstyled from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const LearningJourney = () => {
 const [value, setValue] = useState("1");

 const handleChange = (event, newValue) => {
  setValue(newValue);
 };
 return (
  <>
   <div className="learning-Journey-container">
    <h2>Site Reliability Engineering Learning Journey</h2>
    <div className="lj-menu-wrapper">
     <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
       <Box>
        <TabList role="tablist"
         onChange={handleChange}
         className="main-list"
         variant="scrollable"
         scrollButtons="auto"
         aria-label="lab API tabs example"
        >
         <Tab label="Overall" value="1" className="list1 item" role="tab" />
         <Tab label="Aware" value="2" className="list2 item" role="tab" />
         <Tab label="Equipped" value="3" className="list3 item" role="tab" />
         <Tab label="Competent" value="4" className="list4 item" role="tab" />
         <Tab label="Expert" value="5" className="list5 item" role="tab" />
        </TabList>
       </Box>
       <div className="lj-box">
        <TabPanel value="1" role="tabpanel">
         <div className="lj-images">
          <img
           src="images/SRE/SRE Overall infographic.png"
           alt="overall-img"
           className="lj-images"
          />
         </div>
        </TabPanel>
        <TabPanel value="2" role="tabpanel">
         <div className="lj-images">
          <a
           href="https://deepknowledge.accenture.com/course/view.php?id=984"
           target="_blank"
          >
           <img
            src="images/SRE/SRE-AWARE – 1.png"
            alt="aware-img"
            className="lj-images"
           />
          </a>
          {/* <div className='LJ-link-Wrapp'>
                  <img src='images/SRE/LearningJourney/Aware/SRE-AWARE-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='SREAware'>
                    <p className='link1'>
                      <a href="https://connectedlearning.accenture.com/learningboard/830254-cloud-essentials" target="_blank"><img src='images/SRE/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/6e200420-1d72-11e9-a20f-8b28ecf57cd6/videos/feee3252-e185-4493-92bb-011d29981a78" target="_blank"><img src='images/SRE/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/1908970" target="_blank"><img src='images/SRE/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/track/3cd62fec-7511-4e10-ae37-97b6693dba78" target="_blank"><img src='images/SRE/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/channels/150c1001-0e64-11e7-92d8-37e13b311be2/view/ecf3f630-811f-11e7-bf6c-b5f4c90dd240?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/channels/0d795f10-e19a-11e6-93f3-0242c0a80605?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/9355a771-14c0-11e7-92d9-0242c0a80b07/videos/9355a772-14c0-11e7-92d9-0242c0a80b07" target="_blank"><img src='images/SRE/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/channels/8575b9b6-5528-42d1-ba5c-0e4bf0700582?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Aware/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/b981cb85-110f-488b-9fd7-f224e64f79f8/videos/464b4d15-12a0-4e4b-b84a-a65b53a4a6cd" target="_blank"><img src='images/SRE/LearningJourney/Aware/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/5b868156-7da1-46c8-8d2a-db76a2f752aa/videos/2fe89a84-792c-4263-b571-cdc72e9b8565?sharelink=7EoTXA5uP" target="_blank"><img src='images/SRE/LearningJourney/Aware/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/74550edd-8b5c-411e-b114-c585a1cc5652/videos/3ef1e3cf-2e8c-4463-956d-bc2c291b381f?sharelin" target="_blank"><img src='images/SRE/LearningJourney/Aware/11.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
         </div>
        </TabPanel>
        <TabPanel value="3" role="tabpanel">
         <div className="lj-images">
          <a
           href="https://deepknowledge.accenture.com/course/view.php?id=985"
           target="_blank"
          >
           <img
            src="images/SRE/SRE-Equipped.png"
            alt="equipped-img"
            className="lj-images"
           />
          </a>
          {/* <div className='LJ-link-Wrapp'>
                  <img src='images/SRE/LearningJourney/Equipped/SRE-Equipped-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='SREequipped'>
                    <p className='link1'>
                      <a href="https://connectedlearning.accenture.com/learningboard/791365-agile-essentials" target="_blank"><img src='images/SRE/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/channels/f1c49d66-9f5b-495f-b64e-85809f1cdb00?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/channels/a62bc750-0b22-11e7-a3e9-a39d8b265364?sharelink=gQ_oU55dr&localeCode=en-US&tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/channels/f3619a61-1944-11e7-b488-c198130a9b04/view/b13bc430-1958-11e7-92d9-0242c0a80b07?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/channels/3c79cc00-e1a4-11e6-91a7-0242c0a80704?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/1992007" target="_blank"><img src='images/SRE/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://www.pluralsight.com/paths/fundamentals-of-devsecops" target="_blank"><img src='images/SRE/LearningJourney/Equipped/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://www.pluralsight.com/paths/fundamentals-of-site-reliability-engineering-sre" target="_blank"><img src='images/SRE/LearningJourney/Equipped/8.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
         </div>
        </TabPanel>
        <TabPanel value="4" role="tabpanel">
         <div className="lj-images">
          <a
           href="https://deepknowledge.accenture.com/course/view.php?id=986"
           target="_blank"
          >
           <img
            src="images/SRE/SRE_Competent.png"
            alt="competent-img"
            className="lj-images"
           />
          </a>
          {/* <div className='LJ-link-Wrapp'>
                  <img src='images/SRE/LearningJourney/Competent/SRE-Competent-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='SRECompetent'>
                    <p className='link1'>
                      <a href="https://www.pluralsight.com/paths/managing-source-code-with-git" target="_blank"><img src='images/SRE/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/2020180" target="_blank"><img src='images/SRE/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://app.pluralsight.com/library/courses/azure-devops-services-fundamentals/table-of-contents" target="_blank"><img src='images/SRE/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/channels/4ec244e0-e259-11e6-91a7-0242c0a80704?tab=WATCH" target="_blank"><img src='images/SRE/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/f7689237-ecae-4407-a111-bc869dc5f04d/videos/2f4357ee-13f0-4d79-a38a-b0c6a52bf5af" target="_blank"><img src='images/SRE/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/dea0f1aa-795f-4592-87cb-c512f9920cf2/videos/3e9155ff-7908-43ec-a7dc-fd185cdde982" target="_blank"><img src='images/SRE/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://app.pluralsight.com/paths/skill/managing-and-orchestrating-containers-with-azure-kubernetes-service-aks" target="_blank"><img src='images/SRE/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://app.pluralsight.com/paths/skill/managing-infrastructure-with-terraform" target="_blank"><img src='images/SRE/LearningJourney/Competent/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/1828896/2020132" target="_blank"><img src='images/SRE/LearningJourney/Competent/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://app.pluralsight.com/paths/skill/event-monitoring-and-alerting-with-prometheus" target="_blank"><img src='images/SRE/LearningJourney/Competent/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="#" ><img src='images/SRE/LearningJourney/Competent/11.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
         </div>
        </TabPanel>
        <TabPanel value="5" role="tabpanel">
         <div className="lj-images">
          <a
           href="https://deepknowledge.accenture.com/course/view.php?id=987"
           target="_blank"
          >
           <img src="images/SRE/SRE Expert.png" alt="expert-img" className="lj-images" />
          </a>
         </div>
        </TabPanel>
       </div>
      </TabContext>
     </Box>
    </div>
   </div>
  </>
 );
};
export default LearningJourney;
